import { GridColDef } from "esseal-data-table";
import { List, ListItem, Tooltip } from "@mui/material";
import { CompanyTag, User } from "@/graphql/generated/graphql";
import { arrayLength } from "@/utils/helperFunctions";

const tagsColumns: GridColDef<CompanyTag>[] = [
  {
    field: "title",
    headerName: "Title",
    width: 180,
  },
  {
    field: "users",
    headerName: "Users",
    width: 300,
    renderCell: ({ row }: { row: CompanyTag }) => {
      return <Tooltip title={
        arrayLength(row.users) ?
          <List>
            {row.users?.map((user: User) => (
              <ListItem key={user.id}>
                {user.firstName} {user.lastName}
              </ListItem>
            ))}
          </List>
          : "No users tagged"
      }>
        <span>{arrayLength(row.users)} users</span>
      </Tooltip>
    }
  },
  {
    field: "equipments",
    headerName: "Company Equipments",
    width: 300,
    renderCell: ({ row }: { row: CompanyTag }) => {
      return <Tooltip title={
        arrayLength(row.equipments) ?
          <List>
            {row.equipments?.map((equipment) => (
              <ListItem key={equipment.id}>
                {equipment.name}
              </ListItem>
            ))}
          </List>
          : "No equipments tagged"
      }>
        <span>{arrayLength(row.equipments)} equipments</span>
      </Tooltip>
    }
  }
];

export default tagsColumns;
